import { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';

const AddForm = ({ entityType, group, handleSubmit, entity='' }) => {
  const initialFormData = {
    name: '',
    description: '',
    color: '#FFAB00',
    group: group,
    type: '',
    isRequired: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setButtonLoading(true);
    try {
      const payload = {
        name: formData.name,
        description: formData.description,
        color: formData.color,
        group: formData.group,
        type: formData.type || null,
        isRequired: false,
      };
      await handleSubmit(payload);
      setFormData(initialFormData);
    } catch (error) {
      console.error('Failed to submit form:', error);
    } finally {
      setButtonLoading(false);
    }
  };
  const shouldShowColor =
    entityType?.includes('status') || entityType?.includes('priority');
  const shouldShowDescription =
    entityType?.includes('labels') || entityType?.includes('fields');
  // const shouldShowFieldType = entityType?.includes('fields');

  const namePlaceHolder = 'Name';

  useEffect(() => {
    setFormData(initialFormData);
  }, [entityType]);

  return (
    <Form onSubmit={handleFormSubmit}>
      <Row className="align-items-center g-2">
        <Col>
          <FormGroup controlId="name">
            <FormControl
              type="text"
              required
              placeholder={namePlaceHolder}
              value={formData.name}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
        {!shouldShowDescription && (
          <Col md={6}>
            <FormGroup controlId="description">
              <FormControl
                type="text"
                placeholder="Description"
                value={formData.description}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        )}

        {shouldShowColor && (
          <Col>
            <FormGroup controlId="color">
              <FormControl
                type="color"
                value={formData.color}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        )}
        {/* {shouldShowFieldType && (
          <>
            <Col>
              <FormGroup controlId="type">
                <Form.Select value={formData.type} onChange={handleInputChange}>
                  {fieldsDropdownOptions?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup controlId="isRequired">
                <Form.Check
                  type="checkbox"
                  label="Required"
                  checked={formData.isRequired}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
          </>
        )} */}
        <Col>
          <Button
            variant="primary"
            type="submit"
            title="Add new configuration"
            disabled={buttonLoading}>
            + Add New {entity}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default AddForm;
